export default __webpack_public_path__ + "static/media/13-min.c8abc2c3.jpg";